export enum APP_SOURCE {
    EMAIL = 1,
    WEBSITE = 2,
    REFERRAL = 3,
    PHONE_INQUIRY = 4,
    WORD_OF_MOUTH = 5,
    NEWSLETTER = 6,
    RECRUITER = 7
}